import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import Swal from "sweetalert2";

import {addNewSample} from "../../../slices/SampleFunctionalSlice";
import {setNoNewSample} from "../../../slices/SampleSlice/SampleSlice";
import {getInfo} from "../../../slices/UserSlice";
import {withSampleMod} from "../constants/SampleHOC";
import {SAMPLE_UNI_MOD_INITIAL_INSTANCE_VALUES} from "../SampleUniModal/SampleUniMod";

const SampleCreateModal = ({typeForm}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const onSetClick = data => {};

  const onInstanceClick = (data, setFieldValue, setValues) => {
    dispatch(addNewSample(data)).then(res => {
      if (res.meta.requestStatus === "fulfilled") {
        getInfo(t("ins added"));
        setFieldValue("skuNumber", res.payload.skuNumber);
      }
    });
  };

  const onSetCancel = (data, setValues, resetForm) => {};

  const onInstanceCancel = (data, setValues, resetForm) => {
    Swal.fire({
      title: "",
      text: t("del data"),
      icon: "question",
      confirmButtonText: t("Yes"),
      showCancelButton: true,
      cancelButtonText: t("No"),

      customClass: {
        popup: "zindex",
        container: "zindex",
        htmlContainer: "zindex",
      },
    }).then(answ => {
      if (answ.isConfirmed) {
        resetForm();
        dispatch(setNoNewSample({typeForm}));
      }
    });
  };

  const SampleForm = withSampleMod(
    t("Save"),
    t("Save"),
    onSetClick,
    onInstanceClick,
    onSetCancel,
    onInstanceCancel,
    false,
  );
  return <SampleForm typeForm={typeForm} />;
};

export default SampleCreateModal;
